import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

// Thank You page is Spanish-only per requirements.
export default function ThankYouPage() {
  return (
    <main
      id="main"
      style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
      className="min-h-[70vh] bg-white flex items-center justify-center"
    >
      <div className="mx-auto max-w-2xl px-5 sm:px-8 lg:px-12 py-20 text-center">
        <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">
          <CheckCircle2 size={36} />
        </span>
        <h1
          className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900"
          style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          data-testid="thank-you-title"
        >
          ¡Gracias por tu solicitud!
        </h1>
        <p className="mt-4 text-lg text-slate-700">
          Hemos recibido tu información correctamente. Un responsable podrá
          ponerse en contacto contigo para facilitarte información adicional
          sobre los siguientes pasos.
        </p>
        <p className="mt-3 text-sm text-slate-500">
          Las solicitudes se procesan por orden de recepción. El servicio tiene
          carácter exclusivamente informativo y no garantiza resultados
          concretos.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-flex items-center rounded-md bg-slate-900 px-6 py-3 text-sm font-semibold text-white hover:bg-slate-800 no-underline"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
